module.exports = __webpack_public_path__ + "img/gridGallerySound.227a2255.svg";